import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#0D9488',
          lighten5: '#F0FDFA',
        },
        secondary: '#0D2724',
        accent: '#0284C7',
        success: '#10B981',
        warning: '#F59E0B',
        error: '#E11D48',
        info: '#0284C7',
        background: '#f8fafc',
        surface: '#FFFFFF',
      },
      dark: {
        primary: {
          base: '#2DD4BF',
          lighten5: 'rgba(45, 212, 191, 0.12)',
        },
        secondary: '#0B1E1C',
        accent: '#38BDF8',
        success: '#10B981',
        warning: '#F59E0B',
        error: '#E11D48',
        info: '#0284C7',
        background: '#0B0F19',
        surface: '#131B2E',
      },
    },
  },
});
